export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
    Expired = 3,
}
